// import { AssetType } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { Report_CBCT_IOS_Superimposition_Orientation } from '@/shared/api/protocol-ts/model/dto_report_type_cbct_ios_superimposition_pb';
import { MAX_EXTERNAL_ID_LENGTH } from '@/shared/config';
import { InferType, mixed, object, string } from '@/shared/config/yup';

export const uploadStudySchema = object({
  mainStudyID: string().max(MAX_EXTERNAL_ID_LENGTH),
  IOSMeshesStudyID: string().max(MAX_EXTERNAL_ID_LENGTH),
  SecondaryCBCTStudyID: string().max(MAX_EXTERNAL_ID_LENGTH),
  superimpositionOrientation:
    mixed<Report_CBCT_IOS_Superimposition_Orientation>().default(
      Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_CBCT,
    ),
});

export type UploadStudyPayload = InferType<typeof uploadStudySchema>;
